import React from 'react';
import { CTAButton } from './Shared';
export const HeroSection = () => {
  return <header className="relative overflow-hidden" data-id="element-116">
      <div className="bg-grid absolute inset-0 pointer-events-none" data-id="element-117" />
      <div className="absolute inset-0 bg-gradient-to-b from-megapack-bg to-megapack-section opacity-50 pointer-events-none" data-id="element-118" />

      <div className="relative z-10 max-w-5xl mx-auto px-6 pt-4 pb-8 text-center" data-id="element-119">
        <h1 className="font-display sm:text-4xl md:text-5xl font-bold mb-3 text-[24px]" data-id="element-120">
          El Sistema Completo para Aprobar, <br className="hidden md:block" data-id="element-121" />
          Programar y Conseguir tu <br className="hidden md:block" data-id="element-122" />
          <span className="text-megapack-cyan" data-id="element-123">Primer Trabajo en IT</span>
        </h1>

        <div className="relative max-w-[240px] sm:max-w-[320px] mx-auto mb-4" data-id="element-124">
          <div aria-hidden="true" className="absolute inset-0 bg-megapack-cyan/20 rounded-full hidden sm:block" style={{
          filter: 'blur(40px)'
        }} data-id="element-125" />
          <img src="https://cdn.magicpatterns.com/uploads/ifDKWjzus6v8ub9qP2rj5t/hf_20260521_012224_a6f83777-a6a3-424a-8f9b-193d8ce478fa-removebg-preview.png" alt="Mega Pack Informática 2026 Mockup" width="500" height="500" loading="eager" decoding="async"
        // @ts-ignore
        fetchpriority="high" className="relative z-10 w-full h-auto" data-id="element-126" />
        </div>

        <p className="text-megapack-gray sm:text-base max-w-xl mx-auto mb-4 text-[13px] leading-snug" data-id="element-127">
          6 Módulos + 3 Bonos: Algoritmos, POO, Base de Datos, IA, Técnicas de
          Estudio y Búsqueda Laboral. Todo resuelto. Sin improvisar. Sin
          adivinar.
        </p>

        <div className="flex flex-wrap gap-1.5 mb-6 items-start justify-center" data-id="element-128">
          {['📄 PDF Digital', '⚡ Acceso Inmediato', '🎓 Estudiantes IT', '💥 Sistema Completo', '🇦🇷 Hecho para Argentina'].map((badge, i) => <span key={i} className="bg-megapack-card border border-megapack-cyan/20 px-2.5 py-1 rounded-full text-[9px] sm:text-[11px] font-bold flex items-center gap-1.5" data-id="element-129">
              {badge}
            </span>)}
        </div>

        <CTAButton href="#precio-lanzamiento" className="w-full sm:w-auto text-base px-10 py-3.5 mb-3" data-id="element-130">
          →LO QUIERO AHORA
        </CTAButton>

        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-1.5 text-[9px] sm:text-[11px] text-megapack-gray" data-id="element-131">
          <span className="flex items-center gap-1.5" data-id="element-132">
            🛡️ Garantía de satisfacción de 7 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-133">🔒 Pago 100% seguro</span>
          <span className="flex items-center gap-1.5" data-id="element-134">
            💳 Tarjeta · Mercado Pago · Ualá · Transferencia
          </span>
        </div>
      </div>
    </header>;
};